import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function GoRedirectPage() {
  const { slug } = useParams();
  const [toolName, setToolName] = useState(slug);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get(`/go/${slug}`)
      .then((r) => {
        const { name, url } = r.data;
        if (name) setToolName(name);
        if (url) {
          window.location.href = url;
        } else {
          setError("No redirect URL found for this tool.");
        }
      })
      .catch(() => {
        setError("Tool not found or redirect unavailable.");
      });
  }, [slug]);

  if (error) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center px-4 text-center">
        <p className="text-slate-500 mb-4">{error}</p>
        <Link to="/ai-tools" className="text-sm font-semibold text-green-700 hover:underline">
          Browse all tools →
        </Link>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 text-center">
      <div className="w-8 h-8 border-2 border-green-600 border-t-transparent rounded-full animate-spin mb-4" aria-hidden="true" />
      <p className="text-slate-700 font-medium">Taking you to {toolName}…</p>
      <p className="text-xs text-slate-400 mt-2">You'll be redirected in a moment.</p>
    </div>
  );
}
